export default "__VITE_ASSET__BcJ8dFDk__"